// A creator is unique per platform, not per id: the same numeric id can exist on two platforms.
export const creatorOptionKey = ({ platform, platformId }) => `${platform}|${platformId}`;
// Who may hand a drop's dare to creators. Mirrors the legacy canAccessCreateBrandProjectSelector
// (isAdmin || the drop's own brand) and the server's validateUserSponsor check on
// CREATE_PROJECT_PRODUCT. Deliberately not "any brand": a brand that does not own this drop is a
// plain viewer here and the endpoint would reject them with a 403.
export const canCreateBrandDare = ({ isAdmin, userId, drop }) => {
    var _a, _b;
    if (isAdmin) {
        return true;
    }
    const dropBrandId = (_b = (_a = drop.brand) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : drop.brandId;
    return Boolean(userId && dropBrandId && userId === dropBrandId);
};
export const buildCreateBrandDarePayload = ({ dropId, dare, creators }) => ({
    // The server re-finds the dare on the drop by exact title + description (prepareData / getDareGame),
    // so both must be passed through untouched, exactly as the legacy form did.
    title: dare.title,
    description: dare.description,
    assignees: creators.map(creator => ({ id: creator.platformId, platform: creator.platform })),
    // Straight off the dare: the payload schema forbids extra keys inside paymentInfo, so only the four
    // declared fields go out.
    paymentInfo: {
        paymentType: dare.paymentInfo.paymentType,
        brandProductId: dare.paymentInfo.brandProductId,
        productType: dare.paymentInfo.productType,
        amount: dare.paymentInfo.amount,
    },
    campaign: { campaignId: dropId },
});
// Server error codes worth a plainer sentence than the raw message.
const ERROR_MESSAGE_BY_CODE = {
    NotEnoughKeys: 'Not enough rewards left for this dare. Add more keys before daring these creators.',
    Forbidden: 'You are not allowed to create dares on this campaign.',
    NotFound: 'This campaign is no longer active, so dares cannot be created on it.',
};
// Pulls the gateway error envelope's `code` off a thrown DareDropApiError (it lands on `cause`) and
// maps it to a readable sentence. Returns undefined for anything unrecognised, so the caller can fall
// back to the generic message extractor.
export const brandDareErrorMessage = (error) => {
    const cause = error instanceof Error ? error.cause : undefined;
    if (typeof cause !== 'object' || cause === null || !('code' in cause)) {
        return undefined;
    }
    const { code } = cause;
    return typeof code === 'string' ? ERROR_MESSAGE_BY_CODE[code] : undefined;
};
